import { useForm } from "@inertiajs/react"

const useCreatePuzzle = () => {
  const { post, processing } = useForm()

  const createPuzzle = () => {
    post("/puzzles", {
      async: true,
    })
  }

  return {
    createPuzzle,
    processing,
  }
}

export default useCreatePuzzle
